import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet } from 'react-native';
import { BarCodeScanner } from 'expo-barcode-scanner';
import type { BarCodeScanningResult } from 'expo-camera';
import { Camera } from 'expo-camera';

type QRCodeScannerProps = {
  readonly onRequestPermissionResponse: (granted: boolean) => void;
  readonly onScanSuccess: (code: string) => void;
} & ViewProps;

/**
 * QRCodeScanner
 */
export const QRCodeScanner = ({
  onRequestPermissionResponse,
  onScanSuccess,
}: QRCodeScannerProps) => {
  const [grantedPermission, setGrantedPermission] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      const { granted } = await BarCodeScanner.requestPermissionsAsync();

      onRequestPermissionResponse(granted);
      setGrantedPermission(granted);
    })();
  }, [onRequestPermissionResponse, setGrantedPermission]);

  const handleBarCodeScanned = React.useCallback(
    ({ data }: BarCodeScanningResult) => {
      onScanSuccess(data);
    },
    [onScanSuccess],
  );

  return grantedPermission ? (
    <Camera
      style={StyleSheet.absoluteFillObject}
      onBarCodeScanned={handleBarCodeScanned}
      barCodeScannerSettings={{
        barCodeTypes: [BarCodeScanner.Constants.BarCodeType.qr],
      }}
    />
  ) : null;
};
